module.exports = __webpack_public_path__ + "img/secret.83b0d317.svg";